module.exports = {
	"ecMultipleChart": {
		"components": {
			"autocompleteComparisonFund": {
				"blueprint": "standardUS",
				"components": {
					"searchInput": {
						"labels": {
							"ariaText": {
								"en": "Please use up and down arrow keys to navigate search results"
							},
							"placeholder": {
								"en": "Enter name, ticker, or fund code.",
								"fr": "Entrez nom, symbole, ou code de fonds."
							}
						},
						"type": "ecInput"
					}
				},
				"labels": {
					"ariaLabel": {
						"en": "Comparison Fund field. Enter name, ticker, or fund code. Please use up and down arrow keys to navigate search results",
						"fr": "Fonds/FNB de comparaison. Entrez nom, symbole, ou code de fonds. Servez-vous des flèches pour parcourir les résultats de votre recherche"
					}
				},
				"settings": {
					"propagatedFields": {
						"asOfDate": "asOfDate",
						"category": "category",
						"categoryId": "categoryId",
						"closePrice": "closePrice",
						"inceptionDate": "inceptionDate",
						"name": "name",
						"returnM12": "returnM12",
						"returnM120": "returnM120",
						"returnM255UA": "returnM255UA",
						"returnM36": "returnM36",
						"returnM60": "returnM60",
						"secId": "secId",
						"universe": "universe"
					},
					"restoreResultsOnFocus": "true",
					"securityDataPoints": "name|secId|category|universe|categoryId|inceptionDate|closePrice|asOfDate|returnM12|returnM36|returnM60|returnM120|returnM255UA",
					"showAriaDescribedBy": false,
					"universeId": "FOUSA|FEUSA"
				},
				"type": "ecAutocomplete"
			},
			"autocompletePrimaryFund": {
				"blueprint": "standardUS",
				"components": {
					"searchInput": {
						"labels": {
							"ariaText": {
								"en": "Please use up and down arrow keys to navigate search results"
							},
							"placeholder": {
								"en": "Enter name, ticker, or fund code.",
								"fr": "Entrez nom, symbole, ou code de fonds."
							}
						},
						"type": "ecInput"
					}
				},
				"labels": {
					"ariaLabel": {
						"en": "Primary Fund field. Enter name, ticker, or fund code. Please use up and down arrow keys to navigate search results",
						"fr": "Fonds/FNB primaire. Entrez nom, symbole, ou code de fonds. Servez-vous des flèches pour parcourir les résultats de votre recherche"
					}
				},
				"settings": {
					"name": "autocompletePrimaryFund",
					"propagatedFields": {
						"asOfDate": "asOfDate",
						"category": "category",
						"categoryId": "categoryId",
						"closePrice": "closePrice",
						"inceptionDate": "inceptionDate",
						"name": "name",
						"returnM12": "returnM12",
						"returnM120": "returnM120",
						"returnM255UA": "returnM255UA",
						"returnM36": "returnM36",
						"returnM60": "returnM60",
						"secId": "secId",
						"universe": "universe"
					},
					"restoreResultsOnFocus": "true",
					"securityDataPoints": "name|secId|category|universe|categoryId|inceptionDate|closePrice|asOfDate|returnM12|returnM36|returnM60|returnM120|returnM255UA",
					"showAriaDescribedBy": false,
					"universeId": "FOUSA|FEUSA"
				},
				"type": "ecAutocomplete"
			},
			"buttonExport": {
				"labels": {
					"caption": {
						"en": "Export",
						"fr": "Exporter"
					}
				},
				"settings": {
					"buttonType": "submit",
					"onClick": {}
				},
				"type": "ecButton"
			},
			"buttonReset": {
				"labels": {
					"caption": {
						"en": "Reset",
						"fr": "Réinitialiser"
					}
				},
				"settings": {
					"buttonType": "submit"
				},
				"type": "ecButton"
			},
			"buttonSubmit": {
				"labels": {
					"caption": {
						"en": "Submit",
						"fr": "Soumettre"
					}
				},
				"settings": {
					"buttonType": "submit",
					"onClick": {}
				},
				"type": "ecButton"
			},
			"chartTabs": {
				"settings": {
					"showTabPanel": false
				},
				"type": "ecTabs"
			},
			"chosenReinvestDistributions": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "yes",
								"value": "yes"
							},
							{
								"key": "no",
								"value": "no"
							}
						]
					},
					"controlType": "buttonList"
				},
				"type": "ecChosen"
			},
			"comboBoxFrequency": {
				"type": "ecComboBox"
			},
			"comboBoxInvestmentType": {
				"type": "ecComboBox"
			},
			"comboBoxTimeFrame": {
				"type": "ecComboBox"
			},
			"containerGrowthChart": {
				"settings": {
					"breakpoints": {
						"large": "medium",
						"medium": {
							"groups": {
								"left": {
									"cols": 2,
									"order": 0
								},
								"middle": {
									"cols": 8,
									"order": 1,
									"sections": [
										"sectionAutocomplete",
										"sectionTimeFrame",
										"sectionAmount",
										"sectionFilterReinvestDistributions",
										"sectionActionButton"
									]
								},
								"right": {
									"cols": 2,
									"order": 2
								}
							}
						},
						"small": {
							"groups": {
								"all": {
									"cols": 12,
									"order": 0,
									"sections": [
										"sectionAutocomplete",
										"sectionTimeFrame",
										"sectionAmount",
										"sectionFilterReinvestDistributions",
										"sectionActionButton"
									]
								}
							}
						},
						"xlarge": "medium"
					}
				},
				"type": "ecContainer"
			},
			"containerMultipleChart": {
				"settings": {
					"breakpoints": {
						"defaults": {
							"collapserPosition": "firstPerRow",
							"groups": {
								"all": {
									"cols": 12,
									"order": 0,
									"sections": [
										{
											"autoCollapseMode": "expand",
											"sectionId": "sectionMultipleChartInput"
										},
										"sectionPriceChart",
										"sectionPriceTable",
										"hypotheticalGrowthChart",
										"sectionHypotheticalGrowthTable",
										"sectionPerformanceTable"
									]
								}
							}
						}
					}
				},
				"type": "ecContainer"
			},
			"hypotheticalGrowthChart": {
				"components": {
					"containerHypo": {
						"settings": {
							"breakpoints": {
								"defaults": {
									"groups": {
										"all": {
											"cols": 12,
											"sections": [
												"performanceGraph"
											]
										}
									}
								},
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"sections": [
												"performanceGraph"
											]
										}
									}
								}
							}
						},
						"type": "ecContainer"
					},
					"hypoApplyButton": {
						"type": "ecButton"
					},
					"hypoChosenButton": {
						"type": "ecButton"
					},
					"hypoDateInput": {
						"type": "ecInput"
					},
					"hypoFeesApplyChosen": {
						"type": "ecChosen"
					},
					"hypoFilingStatusChosen": {
						"type": "ecChosen"
					},
					"hypoFrequencyChosen": {
						"type": "ecChosen"
					},
					"hypoFrontLoadTypeChosen": {
						"type": "ecChosen"
					},
					"hypoNumberInput": {
						"type": "ecInput"
					},
					"hypoPayChosen": {
						"type": "ecChosen"
					},
					"hypoReinvestChosen": {
						"type": "ecChosen"
					},
					"hypoReportBuilder": {
						"type": "ecReportBuilder"
					},
					"hypoSettingsButton": {
						"type": "ecButton"
					},
					"hypoSubsequentInvestmentTypeChosen": {
						"type": "ecChosen"
					},
					"hypoTimePeriodTrailingReturnChosen": {
						"type": "ecChosen"
					},
					"performanceGraph": {
						"components": {
							"annualPerformanceTable": {
								"components": {
									"paginator": {
										"type": "ecPaginator"
									},
									"paginatorSticky": {
										"type": "ecPaginator"
									},
									"paginatorTop": {
										"type": "ecPaginator"
									},
									"sortFieldsDropdown": {
										"type": "ecChosen"
									},
									"sortOrderRadio": {
										"type": "ecChosen"
									}
								},
								"type": "ecTable"
							},
							"graphContainer": {
								"type": "ecContainer"
							},
							"tabFrequency": {
								"type": "ecTabs"
							}
						},
						"labels": {
							"inception": {
								"en": "Max"
							},
							"performanceGraph": {
								"en": "Hypothetical Growth",
								"fr": "Graphique de Croissance",
								"fr-CA": "Graphique de Croissance"
							}
						},
						"settings": {
							"showTitle": false
						},
						"type": "ecPerformanceGraph"
					},
					"portfolioData": {
						"type": "ecPortfolioData"
					}
				},
				"labels": {
					"title": {
						"en": "Hypothetical Growth",
						"fr": "Graphique de Croissance"
					}
				},
				"settings": {
					"showLoading": false
				},
				"type": "ecHypotheticalGrowth"
			},
			"hypotheticalGrowthTable": {
				"components": {
					"paginator": {
						"type": "ecPaginator"
					},
					"paginatorSticky": {
						"type": "ecPaginator"
					},
					"paginatorTop": {
						"type": "ecPaginator"
					},
					"sortFieldsDropdown": {
						"type": "ecChosen"
					},
					"sortOrderRadio": {
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).growthData.rows _}}"
						}
					},
					"fields": [
						"name",
						"totalContribution",
						"value",
						"totalGain",
						"return",
						"annualizedEquivalent",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			},
			"inputAmount": {
				"settings": {
					"inputType": "number",
					"name": "inputAmount"
				},
				"type": "ecInput"
			},
			"inputEndDate": {
				"labels": {
					"invalidDate": {
						"en": "Invalid format. Please try again.",
						"fr": "Format invalide. Veuillez réessayer."
					}
				},
				"settings": {
					"inputType": "date",
					"name": "inputEndDate"
				},
				"type": "ecInput"
			},
			"inputFrequency": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"frequency": "annually",
								"key": "annually",
								"list": 1,
								"value": "annually"
							},
							{
								"frequency": "monthly",
								"key": "monthly",
								"list": 2,
								"value": "monthly"
							},
							{
								"frequency": "quarterly",
								"key": "quarterly",
								"list": 3,
								"value": "quarterly"
							},
							{
								"frequency": "semiAnnually",
								"key": "semiAnnually",
								"list": 4,
								"value": "semiAnnually"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "frequency"
				},
				"type": "ecInput"
			},
			"inputInitialAmount": {
				"settings": {
					"inputType": "number",
					"name": "inputInitialAmount"
				},
				"type": "ecInput"
			},
			"inputInvestmentType": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"investmentType": "contribution",
								"key": "invest",
								"list": 1,
								"value": "contribution"
							},
							{
								"investmentType": "withdrawal",
								"key": "withdrawal",
								"list": 2,
								"value": "withdrawal"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "investmentType"
				},
				"type": "ecInput"
			},
			"inputStartDate": {
				"labels": {
					"invalidDate": {
						"en": "Invalid format. Please try again.",
						"fr": "Format invalide. Veuillez réessayer."
					}
				},
				"settings": {
					"inputType": "date",
					"name": "inputStartDate"
				},
				"type": "ecInput"
			},
			"inputTimeFrame": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "sinceInception",
								"list": 1,
								"timeFrame": "sinceInception",
								"value": "sinceInception"
							},
							{
								"key": "customized",
								"list": 2,
								"timeFrame": "customized",
								"value": "custom"
							}
						]
					},
					"inputType": "select",
					"keyField": "list",
					"valueField": "timeFrame"
				},
				"type": "ecInput"
			},
			"performanceTable": {
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).performanceData.rows _}}"
						}
					},
					"fields": [
						"name",
						"returnM12",
						"returnM36",
						"returnM60",
						"returnM120",
						"returnM255UA",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			},
			"priceChart": {
				"components": {
					"annualPerformanceTable": {
						"components": {
							"paginator": {
								"type": "ecPaginator"
							},
							"paginatorSticky": {
								"type": "ecPaginator"
							},
							"paginatorTop": {
								"type": "ecPaginator"
							},
							"sortFieldsDropdown": {
								"type": "ecChosen"
							},
							"sortOrderRadio": {
								"type": "ecChosen"
							}
						},
						"type": "ecTable"
					},
					"graphContainer": {
						"type": "ecContainer"
					},
					"tabFrequency": {
						"settings": {
							"selectedTabIndex": -1
						},
						"type": "ecTabs"
					}
				},
				"labels": {
					"inception": {
						"en": "Max"
					},
					"oneMonth": {
						"en": "1M",
						"fr": "1M",
						"fr-CA": "1m"
					},
					"performanceGraph": {
						"en": "Chart",
						"fr": "Graphique",
						"fr-CA": "Graphique"
					}
				},
				"settings": {
					"_model": {
						"performanceChart": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).securities.priceChartData _}}"
						}
					},
					"_parameters": {
						"dataType": {
							"binding": "{{_ parameters(_).dataType _}}"
						},
						"endDate": {
							"binding": "{{_ parameters(_).endDate _}}"
						},
						"startDate": {
							"binding": "{{_ parameters(_).startDate _}}"
						}
					},
					"chartType": "price",
					"displayFrequency": [
						{
							"labelKey": "oneMonth",
							"value": 1
						},
						{
							"labelKey": "oneYear",
							"value": 12
						},
						{
							"labelKey": "threeYears",
							"value": 36
						},
						{
							"labelKey": "fiveYears",
							"value": 60
						},
						{
							"labelKey": "tenYears",
							"value": 120
						},
						{
							"labelKey": "inception",
							"value": 2400
						}
					],
					"enableCustomDate": true,
					"lineChartSettings": {
						"legendPosition": "top"
					},
					"showTitle": false,
					"timelineLevelDefinitions": {
						"d": {
							"day": [
								0,
								13
							],
							"month": [
								92,
								390
							],
							"quarter": [
								391,
								1170
							],
							"week": [
								14,
								91
							],
							"year": [
								1171,
								36500
							]
						},
						"w": {
							"day": [
								0,
								13
							],
							"month": [
								92,
								390
							],
							"quarter": [
								391,
								1170
							],
							"week": [
								14,
								91
							],
							"year": [
								1171,
								36500
							]
						}
					}
				},
				"type": "ecPerformanceGraph"
			},
			"priceTable": {
				"components": {
					"paginator": {
						"type": "ecPaginator"
					},
					"paginatorSticky": {
						"type": "ecPaginator"
					},
					"paginatorTop": {
						"type": "ecPaginator"
					},
					"sortFieldsDropdown": {
						"type": "ecChosen"
					},
					"sortOrderRadio": {
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"rows": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).securities.priceTableData _}}"
						}
					},
					"fields": [
						"name",
						"startDate",
						"endDate",
						"priceChangePer",
						"currentPrice",
						"inceptionDate"
					]
				},
				"type": "ecTable"
			}
		},
		"labels": {
			"amount": {
				"en": "Amount {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Montant {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"amountRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"annualizedEquivalent": {
				"en": "% Annualized Equivalent",
				"en-GB": null,
				"fr": "Équivalent annualisé (%)",
				"sv-SE": null
			},
			"annually": {
				"en": "Annually",
				"en-GB": null,
				"fr": "Annuelle",
				"sv-SE": null
			},
			"asOfDate": {
				"en": "as of {{format.date(model.rows[0].asOfDate, 'yy-mmm-dd')}}",
				"en-GB": null,
				"fr": "au {{format.date(model.rows[0].asOfDate, 'yy-mmm-dd')}}",
				"sv-SE": null
			},
			"comparisonFund": {
				"en": "Comparison Fund",
				"en-GB": null,
				"fr": "Fonds/FNB de comparaison",
				"sv-SE": null
			},
			"comparisonFundRequired": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"contribution": {
				"en": "Contribution",
				"en-GB": null,
				"fr": "Contribution",
				"sv-SE": null
			},
			"currentPrice": {
				"en": "Current Price",
				"en-GB": null,
				"fr": "Prix actuel",
				"sv-SE": null
			},
			"custom": {
				"en": "Custom",
				"en-GB": null,
				"fr": "Date personnalisée",
				"sv-SE": null
			},
			"date": {
				"en": "Date",
				"en-GB": null,
				"sv-SE": null
			},
			"distribution": {
				"en": "Distribution ({{0}})",
				"en-GB": null,
				"sv-SE": null
			},
			"endDate": {
				"en": "End Date",
				"en-GB": null,
				"fr": "Date de fin",
				"sv-SE": null
			},
			"endDateRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"enterData": {
				"en": "Enter data",
				"en-GB": null,
				"fr": "Entrez les données",
				"sv-SE": null
			},
			"enterDataInstruction": {
				"en": "Screenreader users can press Spacebar to open the menu. Use the arrow keys to navigate and press Enter to make your selection. Mobile user can use explore by touch.",
				"en-GB": null,
				"fr": "Les utilisateurs du lecteur d’écran peuvent appuyer sur la barre d’espace pour ouvrir le menu. Servez-vous des flèches pour vous déplacer et appuyez sur la touche d’entrée pour effectuer votre sélection. Les utilisateurs d’un appareil mobile peuvent se servir de la fonction explorer au toucher.",
				"sv-SE": null
			},
			"fieldShouldBeInteger": {
				"en": "The value you provided is invalid. Please enter a numeric value without commas, decimals, spaces, or special characters.",
				"fr": "La valeur que vous avez fournie n'est pas valide. SVP entrez une valeur numérique sans virgules, décimales, espaces ou caractères spéciaux."
			},
			"hypotheticalGrowthChart": {
				"en": "Hypothetical Growth Chart",
				"en-GB": null,
				"fr": "Graphique de Croissance",
				"sv-SE": null
			},
			"hypotheticalGrowthTable": {
				"en": "Growth Data Table (Initial investment {{ format.currencySymbol(model.currencyId) }}{{ format.number(model.chartSettings.initialInvestmentAmount) }})",
				"en-GB": null,
				"fr": "Tableau de données de croissance (Placement Initial {{ format.number(model.chartSettings.initialInvestmentAmount) }} {{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"inceptionDate": {
				"en": "Inception Date",
				"en-GB": null,
				"fr": "Date de création",
				"sv-SE": null
			},
			"initialAmountRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"initialInvestment": {
				"en": "Initial investment: {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Placement Initial: {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"initialInvestmentAmount": {
				"en": "Initial Investment Amount {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Placement initial {{ format.currencySymbol(model.currencyId) }}",
				"sv-SE": null
			},
			"inputFrequency": {
				"en": "Frequency",
				"fr": "Fréquence"
			},
			"inputInvestmentType": {
				"en": "Investment Type",
				"fr": "Type d'investissement"
			},
			"inputTimeFrame": {
				"en": "Time Frame",
				"fr": "Durée"
			},
			"maxEndDate": {
				"en": "The end date can't be later than current date.",
				"en-GB": null,
				"fr": "La date de fin ne peut pas être ultérieure à la date actuelle.",
				"sv-SE": null
			},
			"maxStartDate": {
				"en": "The start date can't be later than the end date.",
				"en-GB": null,
				"fr": "La date de début ne peut pas être ultérieure à la date de fin.",
				"sv-SE": null
			},
			"monthly": {
				"en": "Monthly",
				"en-GB": null,
				"fr": "Mensuelle",
				"sv-SE": null
			},
			"multipleChartHeader": {
				"en": "Compare and analyze securities",
				"en-GB": null,
				"fr": "Comparez et analysez des titres",
				"sv-SE": null
			},
			"name": {
				"en": "Name",
				"en-GB": null,
				"fr": "Nom",
				"sv-SE": null
			},
			"no": {
				"en": "No",
				"en-GB": null,
				"fr": "Non",
				"sv-SE": null
			},
			"performanceTable": {
				"en": "Returns Data Table (as of {{ format.date(model.performanceData.asofDate, 'yy-mmm-dd') }})",
				"en-GB": null,
				"fr": "Tableau de données de rendements (au {{ format.date(model.performanceData.asofDate, 'yy-mmm-dd') }})",
				"sv-SE": null
			},
			"price": {
				"en": "Yield ({{0}})",
				"en-GB": null,
				"fr": "Rendement ({{0}})",
				"sv-SE": null
			},
			"priceChangePer": {
				"en": "% Price Change",
				"en-GB": null,
				"fr": "% changement de prix",
				"sv-SE": null
			},
			"priceChart": {
				"en": "Price Chart",
				"en-GB": null,
				"fr": "Graphique de Prix",
				"sv-SE": null
			},
			"priceChartTitle": {
				"en": "Chart",
				"en-GB": null,
				"fr": "Graphique",
				"sv-SE": null
			},
			"priceTableTitle": {
				"en": "Price Data Table",
				"en-GB": null,
				"fr": "Tableau de données de prix",
				"sv-SE": null
			},
			"primaryFund": {
				"en": "Primary Fund",
				"en-GB": null,
				"fr": "Fonds/FNB primaire",
				"sv-SE": null
			},
			"primaryFundRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"quarterly": {
				"en": "Quarterly",
				"en-GB": null,
				"fr": "Trimestriel",
				"sv-SE": null
			},
			"reinvestDistributions": {
				"en": "Re-invest Distributions",
				"en-GB": null,
				"fr": "Réinvestir les distributions",
				"sv-SE": null
			},
			"return": {
				"en": "% Return",
				"en-GB": null,
				"fr": "Rendement (%)",
				"sv-SE": null
			},
			"return120": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"return60": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"returnM12": {
				"en": "1 Yr",
				"en-GB": null,
				"fr": "1 A",
				"sv-SE": null
			},
			"returnM120": {
				"en": "10 Yrs",
				"fr": "10 A"
			},
			"returnM255UA": {
				"en": "Since Inception",
				"en-GB": null,
				"fr": "Depuis création",
				"sv-SE": null
			},
			"returnM36": {
				"en": "3 Yrs",
				"en-GB": null,
				"fr": "3 A",
				"sv-SE": null
			},
			"returnM60": {
				"en": "5 Yrs",
				"fr": "5 A"
			},
			"semiAnnually": {
				"en": "Semi-Annually",
				"en-GB": null,
				"fr": "Semiannuel",
				"fr-CA": "Hebdomadaire",
				"sv-SE": null
			},
			"sinceInception": {
				"en": "Since Inception",
				"en-GB": null,
				"fr": "Depuis création",
				"sv-SE": null
			},
			"startDate": {
				"en": "Start Date",
				"en-GB": null,
				"fr": "Date de début",
				"sv-SE": null
			},
			"startDateRequired": {
				"en": "This is a required field. Please enter a value.",
				"en-GB": null,
				"fr": "Ceci est un champ obligatoire. SVP entrez une valeur.",
				"sv-SE": null
			},
			"totalContributionAmount": {
				"en": "Total Contribution Amounts {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Montant total des contributions ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"totalGain": {
				"en": "Total {{ format.currencySymbol(model.currencyId) }} Gain",
				"en-GB": null,
				"fr": "Gain total ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"value": {
				"en": "Value {{ format.currencySymbol(model.currencyId) }}",
				"en-GB": null,
				"fr": "Valeur ({{ format.currencySymbol(model.currencyId) }})",
				"sv-SE": null
			},
			"withdrawal": {
				"en": "Withdrawal",
				"en-GB": null,
				"fr": "Retrait",
				"sv-SE": null
			},
			"yes": {
				"en": "Yes",
				"en-GB": null,
				"fr": "Oui",
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"chartSettings": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": []
				},
				"growthData": {
					"rows": {
						"dataSourceType": "selector",
						"selector": "{{_ model(hypotheticalGrowthChart.portfolioData).securities _}}",
						"transformPipeline": [
							"fromPAAPIHypoToGrowthTable"
						]
					}
				},
				"performanceData": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"asOfDate": null,
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"rows": [],
					"selector": null,
					"transformPipeline": []
				},
				"priceAndDistributions": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"throttleTime": 200,
							"transformPipeline": [
								"toMarketsPriceAndDistributions"
							],
							"watchedPaths": [
								"startDate",
								"endDate",
								"secIds",
								"readyForAPI"
							]
						},
						"url": "//{{baseUrl}}/ra/rdbChartData?tickers={{secIds}}&sd={{startDate}}&ed={{endDate}}&fields=TotalDist,3244&cdt=19&qs_wsid={{sessionId}}",
						"validationExpression": "parameters.readyForAPI"
					},
					"dataSourceType": "api",
					"transformPipeline": [
						"fromMarketsPriceAndDistributions"
					]
				},
				"securities": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"throttleTime": 200,
							"transformPipeline": [
								"toMarkets"
							],
							"watchedPaths": [
								"dataType",
								"startDate",
								"endDate",
								"secIds"
							]
						},
						"url": "//{{baseUrl}}/ra/rdbChartData?f={{dataType}}&fields=HS538&sd={{startDate}}&ed={{endDate}}&tickers={{secIds}}&cdt=2&qs_wsid={{sessionId}}"
					},
					"dataSourceType": "api",
					"transformPipeline": [
						"fromMarkets"
					]
				}
			},
			"_parameters": {
				"dataType": {},
				"endDate": {},
				"startDate": {}
			},
			"_templates": {
				"enterData": "<ec-container mstar-component-id=\"containerGrowthChart\">\r\n    <form name=\"enterData\">\r\n        <ec-section section-id=\"sectionAutocomplete\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('autocompletePrimaryFund')}}-search-input-textbox\">\r\n                    {{::labels.get('primaryFund')}}\r\n                </label>\r\n                <ec-autocomplete mstar-component-id=\"autocompletePrimaryFund\" data-ng-model=\"model.chartSettings.primaryFund\"></ec-autocomplete>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.primaryFundRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('autocompleteComparisonFund')}}-search-input-textbox\">\r\n                    {{::labels.get('comparisonFund')}}\r\n                </label>\r\n                <ec-autocomplete mstar-component-id=\"autocompleteComparisonFund\" data-ng-model=\"model.chartSettings.comparisonFund\"></ec-autocomplete>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.comparisonFundRequired}}\r\n                </div>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionTimeFrame\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                    <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputTimeFrame')}}-select\">{{::labels.get('inputTimeFrame')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputTimeFrame\"\r\n                    data-ng-model=\"model.chartSettings.timeFrame\"></ec-input>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputStartDate')}}-date\">{{::labels.get('startDate')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputStartDate\"\r\n                    data-ng-model=\"model.chartSettings.startDate\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.startDateRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputEndDate')}}-date\">{{::labels.get('endDate')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputEndDate\"\r\n                    data-ng-model=\"model.chartSettings.endDate\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.endDateRequired}}\r\n                </div>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionAmount\" data-ng-show=\"activeType === 'hypotheticalGrowthChart'\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputInitialAmount')}}-number\">{{::labels.get('initialInvestmentAmount')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputInitialAmount\"\r\n                    data-ng-model=\"model.chartSettings.initialInvestmentAmount\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.initialAmountRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputInvestmentType')}}-select\">{{::labels.get('inputInvestmentType')}}</label>\r\n                <ec-input mstar-component-id=\"inputInvestmentType\" data-ng-model=\"model.chartSettings.investmentType\"></ec-input>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputAmount')}}-number\">{{::labels.get('amount')}}</label>\r\n                <ec-input\r\n                    mstar-component-id=\"inputAmount\"\r\n                    data-ng-model=\"model.chartSettings.amount\"></ec-input>\r\n                <div class=\"{{::namespaceClass('__error-message')}}\">\r\n                    {{validationErrors.amountRequired}}\r\n                </div>\r\n            </fieldset>\r\n            <fieldset class=\"{{::namespaceClass('__field-group1')}}\">\r\n                <label class=\"{{::namespaceClass('__label')}}\" for=\"{{::namespaceId('inputFrequency')}}-select\">{{::labels.get('inputFrequency')}}</label>\r\n                <ec-input mstar-component-id=\"inputFrequency\" data-ng-model=\"model.chartSettings.frequency\"></ec-input>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionFilterReinvestDistributions\" data-ng-show=\"activeType === 'hypotheticalGrowthChart'\">\r\n            <fieldset class=\"{{::namespaceClass('__field-group')}}\">\r\n                <legend class=\"{{::namespaceClass('__label')}}\">{{::labels.get('reinvestDistributions')}}</legend>\r\n                <ec-chosen mstar-component-id=\"chosenReinvestDistributions\" data-ng-model=\"model.chartSettings.reinvestDistributions\"></ec-chosen>\r\n            </fieldset>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionActionButton\">\r\n            <div class=\"{{::namespaceClass('__field-group-button')}}\">\r\n                <ec-button mstar-component-id=\"buttonExport\" data-ng-click=\"export()\" data-ng-show=\"activeType === 'priceChart'\" tabindex=\"-1\"></ec-button>\r\n                <ec-button mstar-component-id=\"buttonReset\" data-ng-click=\"reset()\" tabindex=\"-1\"></ec-button>\r\n                <ec-button mstar-component-id=\"buttonSubmit\" data-ng-click=\"submit()\" tabindex=\"-1\"></ec-button>\r\n            </div>\r\n        </ec-section>\r\n    </form>\r\n</ec-container>\r\n",
				"main": "<ec-section>\r\n    <div class=\"{{::namespaceClass('__top')}}\">\r\n        <div class=\"{{namespaceClass('__header')}}\">\r\n            <h2>{{::labels.get('multipleChartHeader')}}</h2>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__tabs')}}\">\r\n            <ec-tabs mstar-component-id=\"chartTabs\">\r\n                <ec-tab-action data-ng-repeat=\"view in settings.get('views')\" name=\"{{::labels.get(view)}}\" on-active=\"setActiveView(index)\">\r\n                </ec-tab-action>\r\n            </ec-tabs>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hidden-text')}}\" tabindex=\"0\">{{::labels.get('enterDataInstruction')}}</div>\r\n    </div>\r\n    <ec-container mstar-component-id=\"containerMultipleChart\" mstar-loader=\"isLoading\">\r\n        <ec-section section-id=\"sectionMultipleChartInput\" title=\"{{labels.get('enterData')}}\">\r\n            <div mstar-include=\"templates.enterData\" title=\"\"></div>\r\n        </ec-section>\r\n        <ec-hypothetical-growth mstar-component-id=\"hypotheticalGrowthChart\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\"></ec-hypothetical-growth>\r\n        <ec-section section-id=\"sectionHypotheticalGrowthTable\" title=\"{{ labels.get('hypotheticalGrowthTable') }}\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"hypotheticalGrowthTable\"></ec-table>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPerformanceTable\" title=\"{{ labels.get('performanceTable') }}\" data-ng-show=\"showHypoGrowthChart && activeType === 'hypotheticalGrowthChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"performanceTable\"></ec-table>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPriceChart\" title=\"{{labels.get('priceChartTitle')}}\" data-ng-show=\"showPriceTable === true && activeType === 'priceChart'\">\r\n            <ec-performance-graph mstar-component-id=\"priceChart\" title=\"\"></ec-performance-graph>\r\n        </ec-section>\r\n        <ec-section section-id=\"sectionPriceTable\" title=\"{{::labels.get('priceTableTitle') }}\" data-ng-show=\"showPriceTable === true && activeType === 'priceChart'\">\r\n            <ec-table template-type=\"light\" mstar-component-id=\"priceTable\" title=\"\"></ec-table>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>\r\n"
			},
			"_validation": {
				"messageWhen": "manual",
				"modelRules": {
					"autocompletePrimaryFund": {
						"data": "{{_ model().chartSettings.primaryFund.name _}}",
						"labelKey": "primaryFundRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputAmount": {
						"data": "{{_ model().chartSettings.amount _}}",
						"labelKey": "amountRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputEndDate": {
						"data": "{{_ model().chartSettings.endDate _}}",
						"labelKey": "endDateRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputInitialAmount": {
						"data": "{{_ model().chartSettings.initialInvestmentAmount _}}",
						"labelKey": "initialAmountRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					},
					"inputStartDate": {
						"data": "{{_ model().chartSettings.startDate _}}",
						"labelKey": "startDateRequired",
						"ok": 1,
						"transformPipeline": [
							{
								"name": "arrayWrap",
								"options": {
									"criteria": [
										{
											"args": "nonEmpty"
										}
									]
								}
							},
							{
								"name": "filter",
								"options": {
									"criteria": [
										{
											"fn": "nonEmpty"
										}
									]
								}
							},
							"size"
						]
					}
				},
				"validationMessageHandlerType": "self"
			},
			"currencyId": "USD",
			"dataType": null,
			"endDate": null,
			"exportSettings": {
				"columnOrder": [
					"date",
					"price",
					"distribution"
				],
				"dateFormatAlias": "yyyy-mm-dd",
				"distributionFormatAlias": "shortDecimal",
				"priceFormatAlias": "shortDecimal"
			},
			"fieldDefinitions": {
				"annualizedEquivalent": {
					"fieldName": "avgAnnualizedReturn",
					"format": "shortDecimal",
					"headerLabelKey": "annualizedEquivalent"
				},
				"currentPrice": {
					"fieldName": "currentPrice",
					"headerLabelKey": "currentPrice"
				},
				"endDate": {
					"fieldName": "endDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "endDate"
				},
				"inceptionDate": {
					"fieldName": "inceptionDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "inceptionDate"
				},
				"name": {
					"fieldName": "name",
					"headerLabelKey": "name"
				},
				"priceChangePer": {
					"fieldName": "priceChangePer",
					"headerLabelKey": "priceChangePer"
				},
				"return": {
					"fieldName": "cumulativeReturn",
					"format": "shortDecimal",
					"headerLabelKey": "return"
				},
				"returnM12": {
					"fieldName": "returnM12",
					"format": "shortDecimal",
					"headerLabelKey": "returnM12"
				},
				"returnM120": {
					"fieldName": "returnM120",
					"format": "shortDecimal",
					"headerLabelKey": "returnM120"
				},
				"returnM255UA": {
					"fieldName": "returnM255UA",
					"format": "shortDecimal",
					"headerLabelKey": "returnM255UA"
				},
				"returnM36": {
					"fieldName": "returnM36",
					"format": "shortDecimal",
					"headerLabelKey": "returnM36"
				},
				"returnM60": {
					"fieldName": "returnM60",
					"format": "shortDecimal",
					"headerLabelKey": "returnM60"
				},
				"startDate": {
					"fieldName": "startDate",
					"format": "yy-mmm-dd",
					"headerLabelKey": "startDate"
				},
				"totalContribution": {
					"fieldName": "totalContributionAmounts",
					"format": "shortDecimal",
					"headerLabelKey": "totalContributionAmount"
				},
				"totalGain": {
					"fieldName": "totalGain",
					"format": "shortDecimal",
					"headerLabelKey": "totalGain"
				},
				"value": {
					"fieldName": "marketValue",
					"fieldSettings": {
						"headerTemplate": "<th>{{labels.get('value')}} ({{labels.get('asOfDate')}})</th>"
					},
					"format": "shortDecimal",
					"headerLabelKey": "value"
				}
			},
			"languageId": "en-US",
			"namespaceClass": "ec-multiple-chart",
			"startDate": null,
			"views": [
				"hypotheticalGrowthChart",
				"priceChart"
			]
		},
		"type": "ecMultipleChart"
	}
};


//////////////////
// WEBPACK FOOTER
// ./components/multiple-chart/src/config/.generated/.defaults.json
// module id = 63
// module chunks = 0